import palette from '../palette';

const muiOutlinedInputOverrides = {
  styleOverrides: {
    root: {
      '&:hover:not($disabled)': {
        backgroundColor: palette.background.default,
      },
    },
  },
};

export default muiOutlinedInputOverrides;
